export var DocumentType;
(function (DocumentType) {
    DocumentType["FINDING"] = "FINDING";
    DocumentType["BLOB"] = "BLOB";
    DocumentType["FILE"] = "FILE";
    DocumentType["PARSED_DATA"] = "PARSED_DATA";
})(DocumentType || (DocumentType = {}));
